import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl } from '@mui/material';
import { CircularProgress, Divider } from '@mui/material';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';

import { addEvent, createEvents, editNotification } from '../../features/fueladmin/fuelSlice';
import { useridSelector } from '../../features/user/UserSlice';

const eventKeys = ['notify_system', 'notify_email', 'notify_email_address', 'notify_sms', 'notify_sms_number',];
const FuelEvent = ({ view, fuelSetup, assetId }) => {

    const dispatch = useDispatch();
    const userid = useSelector(useridSelector);
    const [loading, setLoading] = useState(false);
    const [event, setEvent] = useState({});

    useEffect(() => {
        if (fuelSetup.event) {
            const { notify_system, notify_email, notify_email_address, notify_sms, notify_sms_number } = fuelSetup.event;
            setEvent({
                notify_system: notify_system ?? true,
                notify_email: notify_email ?? false,
                notify_email_address: notify_email_address ?? '',
                notify_sms: notify_sms ?? false,
                notify_sms_number: notify_sms_number ?? '',
            });
        }
    }, [fuelSetup]);




    const updateEvent = (key, value) => {
        setEvent({ ...event, [key]: value });
    }

    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        let fv = true;
        if (event.notify_sms === 'true') {
            if (!event.notify_sms_number) {
                fv = false;
            } else {
                if (event.notify_sms_number.length === 0) {
                    fv = false;
                }
            }
        }
        if (event.notify_email === 'true') {
            if (!event.notify_email_address) {
                fv = false;
            } else {
                if (event.notify_email_address.length === 0) {
                    fv = false;
                }
            }

        }
        setFormValid(fv);
    }, [event])


    const saveEvent = () => {
        setLoading(true);
        dispatch(addEvent({ assetId, ...event }));
        if (view === 'addEvent') {
            dispatch(createEvents({ assetId, userid, ...event }));
        } else if (view === 'editEvent') {
            dispatch(editNotification({ assetId, userid, ...event }));
        } else {
            setLoading(false);
        }
    }

    if (loading) {
        return (
            <div>
                <FormControl sx={{ m: 1, width: '100ch' }} >
                    <CircularProgress />
                </FormControl>
            </div>
        );
    } else {
        return (
            <div>
                <FormControl sx={{ m: 1, width: '100ch' }} >
                    <Typography variant="body1" display="inline">
                        <span><b>Fuel Event Setup</b></span>
                    </Typography>
                </FormControl>
                <FormControl sx={{ m: 1, width: '100ch' }}>
                    <FormLabel id="systemNotif">Send Notifications to Mobile & Web App? </FormLabel>
                    <RadioGroup
                        row
                        name="notify_system"
                        value={event.notify_system ?? false}
                        onChange={(e) => updateEvent(e.target.name, e.target.value)}
                    >
                        <FormControlLabel value={true} control={<Radio />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio />} label="No" />
                    </RadioGroup>
                </FormControl>
                <Divider />
                <FormControl sx={{ m: 1, width: '100ch' }}>
                    <FormLabel id="smsNotif">Send Notifications by SMS? </FormLabel>
                    <RadioGroup
                        row
                        name="notify_sms"
                        value={event.notify_sms ?? false}
                        onChange={(e) => updateEvent(e.target.name, e.target.value)}
                    >
                        <FormControlLabel value={true} control={<Radio />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio />} label="No" />
                    </RadioGroup>
                </FormControl>
                <br />
                {
                    event.notify_sms &&
                    <FormControl sx={{ m: 1, width: '90ch' }}>
                        <FormLabel id="smsNotifNumbers">SMS Numbers? </FormLabel>
                        <TextField
                            label="Mobile Numbers"
                            id="notify_sms_number"
                            value={event.notify_sms_number}
                            onChange={(e) => updateEvent(e.target.id, e.target.value)}
                            sx={{ m: 1, width: '80ch' }}
                            variant="standard"
                        />
                    </FormControl>
                }

                <Divider />

                <FormControl sx={{ m: 1, width: '100ch' }}>
                    <FormLabel id="emailNotif">Send Notifications by Email? </FormLabel>
                    <RadioGroup
                        row
                        name="notify_email"
                        value={event.notify_email ?? false}
                        onChange={(e) => updateEvent(e.target.name, e.target.value)}
                    >
                        <FormControlLabel value={true} control={<Radio />} label="Yes" />
                        <FormControlLabel value={false} control={<Radio />} label="No" />
                    </RadioGroup>
                </FormControl>
                <br />
                {
                    event.notify_email &&
                    <FormControl sx={{ m: 1, width: '90ch' }}>
                        <FormLabel id="smsNotifNumbers">Email Addresses? </FormLabel>
                        <TextField
                            label="Email Addresses"
                            id="notify_email_address"
                            value={event.notify_email_address}
                            onChange={(e) => updateEvent(e.target.id, e.target.value)}
                            sx={{ m: 1, width: '80ch' }}
                            variant="standard"
                        />
                    </FormControl>

                }

                <FormControl sx={{ m: 1, width: '30ch' }} >
                    <Button onClick={() => saveEvent()} disabled={!formValid}>
                        Save Event
                    </Button>
                </FormControl>
            </div>
        )
    }
}

export default FuelEvent;